export default __webpack_public_path__ + "static/media/024-stall food.ac8c4010.svg";